<template>
  <v-container>
    <v-alert
      v-model="isError"
      dismissible
      type="error"
      transition="fade-transition"
    >
      {{ errMessage }}
    </v-alert>
    <h1>Churches</h1>
    <v-data-table
      :headers="headers"
      :items="churches"
    >
      <template slot="items" slot-scope="props">
        <td>{{ props.item.name }}</td>
        <td>{{ props.item.city }}</td>
        <td>{{ props.item.state }}</td>
        <td>{{ props.item.approvedAt }}</td>
        <td>{{ props.item.originator || 'N/A' }}</td>
        <td>
          <v-icon small @click="editChurch(props.item)">edit</v-icon>
          <v-icon small @click="manageChurch(props.item)">exit_to_app</v-icon>
          <v-icon
            small
            @click="approveChurch(props.item)"
            v-if="!props.item.approvedAt"
          >thumb_up
          </v-icon>
        </td>
      </template>
    </v-data-table>
    <v-btn to="/admin/churches/new">Add</v-btn>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    isError: false,
    errMessage: null,
    churches: [],
    headers: [
      { text: 'Name', value: 'name' },
      { text: 'City', value: 'city' },
      { text: 'State', value: 'state' },
      { text: 'Approved Since', value: 'approvedAt' },
      { text: 'Originator', value: 'originator' },
      { text: 'Actions', value: 'name' } // no actual value
    ]
  }),
  mounted: function () {
    var _this = this
    this.axios.get('/churches/')
      // Get church information
      .then(function (res) {
        _this.churches = res.data
      })
      // Get a primary contact for each church
      .then(function () {
        for (var i in _this.churches) {
          var c = _this.churches[i]
          _this.axios.get('/churches/' + c.id + '/staff', {
            data: {
              churchID: c.id // this isn't used by the request, but we need to reference it later
            }
          })
            .then(function (res) {
              var churchID = JSON.parse(res.config.data).churchID

              // We only want the staff member with the lowest ID number (i.e.,
              // the one who registered the church). The returned IDs should be
              // sorted anyway, but we want to make sure
              var ids = res.data.sort()

              // There's no sane way a church could end up with no staff, but we
              // check for it anyway to avoid errors
              if (ids.length > 0) {
                // Now we need to get information about this particular user
                var id = ids[0]
                _this.axios.get('/auth/users/' + id)
                  .then(function (res) {
                    // Find the church that matches this user
                    for (var i in _this.churches) {
                      if (_this.churches[i].id === churchID) {
                        // We have a match, now find which auth field has a usable
                        // email address
                        var email
                        if (res.data[0].local.email) {
                          email = res.data[0].local.email
                        } else if (res.data[0].google.email) {
                          email = res.data[0].google.email
                        } else if (res.data[0].facebook.email) {
                          email = res.data[0].facebook.email
                        } else {
                          email = 'N/A'
                        }
                        _this.churches[i].originator = email
                        break
                      }
                    }
                    // All we want to do is update _this.churches, but changing
                    // properties in this context doesn't propagate a rendering update,
                    // so we force the creation of a new object instead.
                    // TODO: Find a better way to force the rendering update.
                    _this.churches = _this.churches.slice()
                  })
                  .catch(_this.$root.apiErrorHandler())
              }
            })
            .catch(_this.$root.apiErrorHandler())
        }
      })
      .catch(this.$root.apiErrorHandler())
  },
  methods: {
    editChurch: function (c) {
      this.$router.push('/admin/churches/' + c.id)
    },
    manageChurch: function (c) {
      this.$router.push('/manage/church/' + c.id)
    },
    approveChurch: function (c) {
      // Confirm with the user that they want to perform the requested action
      // before actually making the request
      var _this = this
      confirm('Do you want to approve this church for public listing?') &&
      this.axios.post('/approvals/church/' + c.id)
        .then(function (res) {
          // Update the approval value in our data
          c.approvedAt = res.data.approvedAt
        })
        .catch(this.$root.apiErrorHandler(function (msg) {
          _this.errMessage = msg
          _this.isError = true
        }))
    }
  }
}
</script>
